// extracted by mini-css-extract-plugin
module.exports = {"button":"_0936561","stakeError":"_7bb99fa"};